import { Action, ActionCreator } from '@reduxjs/toolkit';
import { useContext } from 'react';
import { useDispatch } from 'react-redux';

import { GetValues } from '@tdp/common/shared/tsUtils';

import { DevPortalRoot } from './compositionRoot';
import { DeveloperPortalRootContext } from './TdpServicesContext';

// Need top type for parameterized type.
export type CommandCreators<
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  TCommandMap extends Record<string, Record<string, ActionCreator<any>>>,
> = GetValues<GetValues<TCommandMap>>;

/**
 * Get a bound command creator from the map of declared command creators
 *
 * Note: This has the `dispatch` call built-in.
 * @param selector function for selecting an individual creator
 * @returns a bound command creator
 * @see https://redux.js.org/understanding/thinking-in-redux/glossary#action-creator
 */
export function useCommand<
  TCommand extends CommandCreators<DevPortalRoot['commands']>,
>(
  selector: (root: DevPortalRoot['commands']) => TCommand
): (...args: Parameters<TCommand>) => void {
  const services = useContext(DeveloperPortalRootContext);
  // TODO(nibeauli): root cause this or raise it with TS team.
  // type cast is because typescript doesn't believe a union of spreadable/tuples is spreadable.
  const actionCreator = selector(services.commands) as (
    ...args: unknown[]
  ) => Action;
  const dispatch = useDispatch();
  return function (...args: Parameters<TCommand>) {
    const action = actionCreator(...(args as unknown[]));
    dispatch(action);
  };
}
